import { useEffect, useMemo, useState } from "react";
import { useStyles } from "./RCAMeetingTypesDropdown.styles";
import NewMainSelect from "components/NewMainSelect/NewMainSelect.view";
import { useTranslation } from "react-i18next";
import { MeetingTypeEntity } from "entities/RCA/MeetingTypeEntity/MeetingTypeEntity";
import { handleNameTranslation } from "utilities/localesUtilities";
import { IOption } from "components/NewMainSelect/NewMainSelectInterfaces";
import { IRCAMeetingTypesDropdown } from "./RCAMeetingTypesDropdownInterfaces";

const RCAMeetingTypesDropdown = ({
    value,
    onChange,
    handleOnComponentMount,
    multiple,
    className,
    fullWidth,
    placeholder,
    disabled,
    filterOutId,
    notSelectedOption,
}: IRCAMeetingTypesDropdown) => {
    const { meetingTypes } = MeetingTypeEntity.GetMeetingTypes(filterOutId);
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    const [startupStatusAssignedSetted, setStartupStatusAssignedSetted] = useState(false);

    const orderedOptions = useMemo(() => {
        const currentMeetingList = [...meetingTypes];
        if (currentMeetingList && currentMeetingList.length > 0) {
            return currentMeetingList.sort((a, b) => {
                if (a?.default_translation && !b?.default_translation) return -1;
                if (!a?.default_translation && b?.default_translation) return 1;
                return 0;
            });
        }
        return [];
    }, [meetingTypes]);

    const options = useMemo(
        () =>
            orderedOptions.map((type) => {
                if (type.default_translation) {
                    return {
                        id: type.id,
                        name: handleNameTranslation(
                            i18n.language,
                            type.default_translation.default_meeting_translation_names,
                        ),
                    };
                } else {
                    return {
                        id: type.id,
                        name: handleNameTranslation(
                            i18n.language,
                            type?.translation?.translation_names as { name: string; language_id: number }[],
                        ),
                    };
                }
            }) as IOption[],
        [orderedOptions, i18n.language],
    );

    useEffect(() => {
        if (multiple && options.length > 0 && !startupStatusAssignedSetted) {
            if (handleOnComponentMount) handleOnComponentMount([...options.map((option) => option.id)]);
            setStartupStatusAssignedSetted(true);
        }
    }, [multiple, startupStatusAssignedSetted, handleOnComponentMount, options]);

    if (multiple) {
        return (
            <NewMainSelect
                notSelectedOption={notSelectedOption}
                fullWidth={false}
                disableMenuPropsStyles
                disabled={disabled}
                multiple
                className={`${classes.select} ${className || ""} ${fullWidth ? classes.fullWidth : ""}`}
                options={options}
                value={value}
                onChange={(selected) => {
                    onChange(selected);
                }}
                placeholder={placeholder || t("rca.meeting_type_select.select_type")}
                withSearchBar
            />
        );
    }

    return (
        <NewMainSelect
            fullWidth={false}
            disableMenuPropsStyles
            disabled={disabled}
            multiple={false}
            withSearchBar
            className={`${classes.select} ${className || ""} ${fullWidth ? classes.fullWidth : ""}`}
            options={options}
            value={value}
            onChange={(selected) => {
                onChange(selected);
            }}
            placeholder={placeholder || t("rca.meeting_type_select.select_type")}
        />
    );
};

export default RCAMeetingTypesDropdown;
